import {
    ForgotPasswordRequest,
    ForgotPasswordResponse,
    ConfirmForgotPasswordRequest,
    ConfirmForgotPasswordResponse
} from '../forgotpassword';
import * as _m0 from "protobufjs/minimal";
import { getServiceUrl } from '../utils/api';

export async function forgotPassword(email: string): Promise<{ success: boolean; error?: string }> {
    const request: ForgotPasswordRequest = {
        email: email,
    };

    const encodedRequest = ForgotPasswordRequest.encode(request).finish();
    const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

    const url = getServiceUrl('authservice', 'forgotpassword');

    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        body: base64
    });

    if (response.status === 429) {
        return { success: false, error: 'Too many attempts. Please try again later.' };
    }

    if (response.status !== 200) {
        try {
            const errorData = await response.json();
            return { success: false, error: errorData.error || 'Failed to send verification code' };
        } catch {
            return { success: false, error: 'Failed to send verification code' };
        }
    }

    return { success: true };
}

export async function confirmForgotPassword(
    email: string,
    verificationCode: string,
    newPassword: string
): Promise<{ success: boolean; error?: string }> {
    const request: ConfirmForgotPasswordRequest = {
        email: email,
        verificationCode: verificationCode,
        newPassword: newPassword,
    };

    const encodedRequest = ConfirmForgotPasswordRequest.encode(request).finish();
    const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

    const url = getServiceUrl('authservice', 'confirmforgotpassword');

    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        body: base64
    });

    if (response.status === 429) {
        return { success: false, error: 'Too many attempts. Please try again later.' };
    }

    if (response.status !== 200) {
        try {
            const errorData = await response.json();
            return { success: false, error: errorData.error || 'Failed to reset password' };
        } catch {
            return { success: false, error: 'Failed to reset password' };
        }
    }

    return { success: true };
}
